import { render } from "./PetDescriptionPage.vue?vue&type=template&id=06cdbf28&scoped=true"
import script from "./PetDescriptionPage.vue?vue&type=script&lang=js"
export * from "./PetDescriptionPage.vue?vue&type=script&lang=js"

import "./PetDescriptionPage.vue?vue&type=style&index=0&id=06cdbf28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cdbf28"]])

export default __exports__